import React, { Component } from "react";

import Grid from "@mui/material/Grid";
import * as ajax from "helpers/ajax";
import Calendar from 'react-calendar'
import PageDivider from "components/PageDivider";
import 'react-calendar/dist/Calendar.css';

import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import styles from "./index.module.css";
import MapContainer from "components/GoogleMap";
import MenuItem from '@mui/material/MenuItem';
import { toPrice, calculateFinalDate, calculateImportoContrattuale } from "helpers/functions.js"
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";
import { toEuropeanDate } from "../../helpers/functions";



export default class DataAndCalendar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.id,
            data: null,
            loading: true,
            gara:this.props.gara,
        };
    }


    componentDidMount = () => {
        this.load()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.gara !== this.props.gara) {
            this.setState({ gara: this.props.gara });
        }
    }

    load = () => {
        this.setState({ loading: true })
        ajax.ajaxGetStrapi("commessas/" + this.state.id+"?populate=*", this.loadCallback)
    }

    loadCallback = (response) => {
        this.setState({ 
            data: response.data, 
            gara: response.data?.gara || this.props.gara,
            loading: false 
        })
    }

    save = () => {
        let formdata = { data: this.state.data }
        ajax.ajaxPutStrapi("commessas/" + this.state.id, formdata)
        this.props.onChange(this.state.data);
    }

    setChanges = (val, name) => {
        let data = this.state.data;
        data[name] = val;

        this.setState({ data: data })
    }

    checkAddress = (string, name) => {
        ajax.getPositionFromAddress(string, this.checkAddressCallback, name)
    }

    checkAddressCallback = (response, key) => {
        if (response.results.length <= 0) {
            this.setChanges(null, "longitudine");
            this.setChanges(null, "latitudine");
            return;
        }

        let data = this.state.data;
        data["longitudine"] = response.results[0].geometry.location.lng;
        data["latitudine"] = response.results[0].geometry.location.lat;
        data[key] = response.results[0].formatted_address;

        this.setState({ data: data }, this.endCheckAddress)
    }

    endCheckAddress = () => {
        this.save()
    }

    marker = () => {
        let markers = []

        if (this.state.data.latitudine_indirizzo && this.state.data.longitudine_indirizzo) {
            markers.push({ position: { lat: this.state.data.latitudine_indirizzo, lng: this.state.data.longitudine_indirizzo } })
        }

        if (this.state.data.latitudine_Indirizzo_2 && this.state.data.longitudine_Indirizzo_2) {
            markers.push({ position: { lat: this.state.data.latitudine_Indirizzo_2, lng: this.state.data.longitudine_Indirizzo_2 } })
        }

        if (this.state.data.latitudine_Indirizzo_3 && this.state.data.longitudine_Indirizzo_3) {
            markers.push({ position: { lat: this.state.data.latitudine_Indirizzo_3, lng: this.state.data.longitudine_Indirizzo_3 } })
        }

        this.state.data.incarichi.map((el) => {
            if (el.latitudine_indirizzo && el.longitudine_indirizzo) {
                markers.push({ mini: true, position: { lat: el.latitudine_indirizzo, lng: el.longitudine_indirizzo } })
            }

            if (el.latitudine_Indirizzo_2 && el.longitudine_Indirizzo_2) {
                markers.push({ mini: true, position: { lat: el.latitudine_Indirizzo_2, lng: el.longitudine_Indirizzo_2 } })
            }

            if (el.latitudine_Indirizzo_3 && el.longitudine_Indirizzo_3) {
                markers.push({ mini: true, position: { lat: el.latitudine_Indirizzo_3, lng: el.longitudine_Indirizzo_3 } })
            }
        })

        return markers;
    }


    render() {
        if (!this.state.data) {
            return null;
        }

        let importoProposto = calculateImportoContrattuale(this.state.data,false)

        return (
            <>
                <PageDivider text={(this.state.data.commessa_madre)?"Dati dell' incarico":"Dati della commessa"} />
                <Grid container mb={5} alignItems="center" justifyContent="center">
                    <Grid item sm={12} md={8} pr={5}>
                        <Grid container alignItems="center" mb={2}>
                                <MDTypography variant={"label"} mr={2}>Nome Commessa</MDTypography>
                            <MDTypography sx={{ borderBottom: "1px solid #d2d6da", flex:1 }} variant={"body2"} mr={2}>{(this.state.data.commessa_madre) ? this.state.data.commessa_madre.nome : this.state.data.nome}</MDTypography>
                        </Grid>

                        {(this.state.data.commessa_madre) ?
                            <Grid container alignItems="center" mb={2}>
                                <MDTypography variant={"label"} mr={2}>Nome Incarico</MDTypography>
                                <MDTypography sx={{ borderBottom: "1px solid #d2d6da", flex: 1 }} variant={"body2"} mr={2}>{this.state.data.nome}</MDTypography>
                            </Grid>
                            : null
                        }

                        {(this.state.data.commessa_madre) ?
                            <Grid container alignItems="center" mb={2}>
                                <MDTypography variant={"label"} mr={2}>Codice identificativo</MDTypography>
                                <MDTypography sx={{ borderBottom: "1px solid #d2d6da", flex: 1 }} variant={"body2"} mr={2}>{this.state.data.codice_identificativo}</MDTypography>
                            </Grid>
                            : null
                        }
                        <Grid container alignItems="center" mb={5}>
                            <MDTypography variant={"label"} mr={2}>Indirizzo</MDTypography>
                            <MDTypography sx={{ borderBottom: "1px solid #d2d6da", flex: 1 }} variant={"body2"} mr={2}>{this.state.data.indirizzo}</MDTypography>
                        </Grid>

                        {this.state.data.Indirizzo_2 ?
                            <Grid container alignItems="center" mb={5}>
                                <MDTypography variant={"label"} mr={2}>Indirizzo 2</MDTypography>
                                <MDTypography sx={{ borderBottom: "1px solid #d2d6da", flex: 1 }} variant={"body2"} mr={2}>{this.state.data.Indirizzo_2}</MDTypography>
                            </Grid>
                            : null}

                        {this.state.data.Indirizzo_3 ?
                            <Grid container alignItems="center" mb={5}>
                                <MDTypography variant={"label"} mr={2}>Indirizzo 3</MDTypography>
                                <MDTypography sx={{ borderBottom: "1px solid #d2d6da", flex: 1 }} variant={"body2"} mr={2}>{this.state.data.Indirizzo_3}</MDTypography>
                            </Grid>
                            : null}

                        <Grid container alignItems="center" mb={2}>
                            <MDTypography variant={"label"} mr={2}>Oggetto Lavori</MDTypography>
                            <MDTypography sx={{ borderBottom: "1px solid #d2d6da", flex: 1 }} variant={"body2"} mr={2}>{this.state.data.oggetto_lavori}</MDTypography>
                        </Grid>
                        <Grid container alignItems="center" mb={5}>
                            <MDTypography variant={"label"} mr={2}>Committente</MDTypography>
                            <MDTypography sx={{ borderBottom: "1px solid #d2d6da", flex: 1 }} variant={"body2"} mr={2}>{this.state.data.committente}</MDTypography>
                        </Grid>

                        <Grid container alignItems="center" mb={5}>
                            <Grid item sm={12} md={6} mb={2}>
                                <Grid container pr={2}>
                                    <MDTypography variant={"label"} mr={2}>Data Inizio Lavori</MDTypography>
                                    <MDTypography sx={{ borderBottom: "1px solid #d2d6da", flex: 1 }} variant={"body2"} mr={2}>{toEuropeanDate(this.state.data.data_inizio)}</MDTypography>
                                </Grid>
                            </Grid>
                            <Grid item sm={12} md={6} mb={2}>
                                <Grid container pr={2}>
                                    <MDTypography variant={"label"} mr={2}>Data fine lavori contrattuali</MDTypography>
                                    <MDTypography sx={{ borderBottom: "1px solid #d2d6da", flex: 1 }} variant={"body2"} mr={2}>{calculateFinalDate(this.state.data.data_inizio, this.state.data.durata + this.state.data.proroga, (this.state.data.days_type == "Lavorativi") ? true : false)}</MDTypography>
                                </Grid>
                            </Grid>
                            <Grid item sm={12} md={6} mb={2}>
                                <Grid container pr={0}>
                                    <MDTypography variant={"label"} mr={2}>Durata</MDTypography>
                                    <MDTypography sx={{ borderBottom: "1px solid #d2d6da", flex: 1 }} variant={"body2"} mr={2}>{this.state.data.durata + " giorni " + this.state.data.days_type}</MDTypography>
                                </Grid>
                            </Grid>
                            <Grid item sm={12} md={6} mb={2}>
                                <Grid container pr={2}>
                                    <MDTypography variant={"label"} mr={2}>Proroga</MDTypography>
                                    <MDTypography sx={{ borderBottom: "1px solid #d2d6da", flex: 1 }} variant={"body2"} mr={2}>{this.state.data.proroga}</MDTypography>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid container alignItems="center" mb={5}>
                            <Grid item sm={12} md={12} mb={2} >
                                <Grid container pr={0}>
                                    <MDTypography variant={"label"} mr={2}>Responsabile Cantiere</MDTypography>
                                    <MDTypography sx={{ borderBottom: "1px solid #d2d6da", flex: 1 }} variant={"body2"} mr={2}>{this.state.data.responsabile_cantiere}</MDTypography>
                                </Grid>
                            </Grid>
                            <Grid item sm={12} md={6} mb={2}>
                                <Grid container pr={2}>
                                    <MDTypography variant={"label"} mr={2}>Stato Cantiere</MDTypography>
                                    <MDTypography sx={{ borderBottom: "1px solid #d2d6da", flex: 1 }} variant={"body2"} mr={2}>{this.state.data.stato}</MDTypography>
                                </Grid>
                            </Grid>
                            <Grid item sm={12} md={6} mb={2}>
                                <Grid container pr={0}>
                                    <MDTypography variant={"label"} mr={2}>Direzione Lavori</MDTypography>
                                    <MDTypography sx={{ borderBottom: "1px solid #d2d6da", flex: 1 }} variant={"body2"} mr={2}>{this.state.data.direzione_lavori}</MDTypography>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid container alignItems="center" mb={5}>
                            <Grid item sm={12} mb={2}>
                                <Grid container>
                                    <MDTypography variant={"label"} mr={2}>Importo contrattuale</MDTypography>
                                    <MDTypography sx={{ borderBottom: "1px solid #d2d6da", flex: 1 }} variant={"body2"} mr={2}>{toPrice(importoProposto)}</MDTypography>
                                </Grid>
                            </Grid>
                            <Grid item sm={12} md={6} mb={2}>
                                <Grid container>
                                    <MDTypography variant={"label"} mr={2}>Costo manodopera preventivato</MDTypography>
                                    <MDTypography sx={{ borderBottom: "1px solid #d2d6da", flex: 1 }} variant={"body2"} mr={2}>{toPrice(this.state.data.costo_manodopera)}</MDTypography>
                                </Grid>
                            </Grid>
                            <Grid item sm={12} md={6} mb={2}>
                                <Grid container>
                                    <MDTypography variant={"label"} mr={2}>Costo Ordini preventivato</MDTypography>
                                    <MDTypography sx={{ borderBottom: "1px solid #d2d6da", flex: 1 }} variant={"body2"} mr={2}>{toPrice(this.state.data.costo_ordini)}</MDTypography>
                                </Grid>
                            </Grid>
                        </Grid>

                        <MDTypography variant={"label"} mr={2}>Note</MDTypography><br />
                        <MDInput InputProps={{ disabled: true }} variant="outlined" multiline rows={6} sx={{ flex: 1, backgroundColor: "white!important", width: "100%" }} value={this.state.data.note}
                            //onChange={(e) => this.setChanges(e.target.value, "note")}
                            //onBlur={() => this.save()}
                        />


                    </Grid>
                    <Grid item sm={12} md={4}>
                        <Grid container>
                            <Grid item sm={12} mb={2}>
                                <MDTypography variant={"label"} mr={2}>Stato Avanzamento Lavori</MDTypography><br />

                                {this.props.sal}
                            </Grid>

                            {this.state.data.gara ?
                                <Grid item sm={12} mb={2} pt={1} pb={1} style={{ border: "1px solid #d2d6da", borderLeftWidth: 0, borderRightWidth: 0, display: "flex", justifyContent: "space-between" }}>
                                    <MDTypography variant={"label"}>Visualizza dati Gara</MDTypography>
                                    <MDButton variant="gradient" color="success" iconOnly
                                        onClick={() => this.props.openGara(this.state.gara)}
                                    >
                                        <Icon>visibility</Icon>
                                    </MDButton>
                                </Grid>
                                : null
                            }

                            <Grid item sm={12} mb={3}>
                                <Calendar className={styles.calendar} />
                            </Grid>
                            <Grid item sm={12}>
                                {this.state.loading ? null :
                                    <MapContainer
                                        key={this.state.data.latitudine + "-" + this.state.data.longitudine}
                                        center={{
                                            lat: this.state.data.latitudine_indirizzo,
                                            lng: this.state.data.longitudine_indirizzo
                                        }}
                                        marker={this.state.loading ? [] : this.marker()}
                                        height={400}
                                    />
                                }
                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>
            </>
        )
    }
}


